import styles from './DashboardHeading.less';

import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';

import { ScreenReaderOnly } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';

export default class DashboardHeading extends Component {

  static propTypes = {
    label: PropTypes.string.isRequired,
    count: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    Icon: PropTypes.func.isRequired,
    iconClass: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    analytics: PropTypes.string.isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { label, count, Icon, iconClass, className, href, analytics } = this.props;

    return (
      <ExternalLink
        className={classnames(styles.root, className)}
        href={href}
        analytics={analytics}>
        <ScreenReaderOnly>
          <h1>{`${count} ${label}`}</h1>
        </ScreenReaderOnly>
        <Icon className={iconClass} svgClassName={styles.iconSvg} />
        <span aria-hidden="true" className={styles.count} data-automation="dashboardHeadingCount">
          {count}
        </span>
        <span aria-hidden="true" className={styles.name}>{label}</span>
      </ExternalLink>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/Dashboard/components/SignedInDashboard/components/DashboardHeading/DashboardHeading.js
 **/